<template>
    <div class="ProfileBar">
        <slot name="profile">
            <RPProfile
                :user-profile="userProfile"
                @sign-out="e => $emit('sign-out')"
                @nav-to-profile="$emit('nav-to-profile')"
            />
        </slot>

        <slot name="notifications">
            <RPNotifications
                :reports="reports"
                :notifications="notifications"
                @report="r => $emit('report', r)"
                @notification="n => $emit('notification', n)"
                @download="d => $emit('download', d)"
                @notification-page="$emit('notification-page')"
                @delete-notification="id => $emit('delete-notification', id)"
            />
        </slot>

        <slot name="help">
        </slot>
    </div>
</template>
<script>
import RPNotifications from './RPNotifications/RPNotifications.vue';
import RPProfile from './RPProfile/RPProfile.vue';
import {QuestionCircle} from '@reviewpush/streamline-regular/lib/interface-essential/Alerts';
import {textGrey} from 'style/_colors.scss';

export default {
    name: 'ProfileBar',
    components: {
        RPProfile,
        RPNotifications
    },
    props: {
        userProfile: {
            type: Object,
            default: () => ({
                first_name: '',
                email: '',
                role_name: '',
                profile_image: '',
            })
        },
        reports: {
            type: Array,
            default: () => ([])
        },
        notifications: {
            type: Array,
            default: () => ([])
        },
    },

};
</script>
<style lang="scss">
    .ProfileBar {
        height: 100%;
        border-left: 1px solid $grey-100;
        padding: 0 1rem;
        margin-left: 1rem;
        white-space: nowrap;
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
    }
</style>